import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FeatureFlagContext } from '../contextProviders/featureFlagContext';
import { useGetPetPhotoQuery } from '../data/pet';
import { SLICES } from '../constants/slices';
import { getPetPhotoPath } from '../utils/mwEndpointUtils';

export const usePetPhotoUrl = (photoUrl, fullPolicyNumber) => {
  const { cspConfiguration } = useContext(FeatureFlagContext) || {};
  const isV3PenTestRemediationEndpointsEnabled = cspConfiguration?.IsV3PenTestRemediationEndpointsEnabled;
  const { auth0AccessToken } = useSelector((state) => state?.[SLICES.AUTHENTICATION]?.authDetails || {});
  const photoPath = getPetPhotoPath(photoUrl);
  const shouldFetchV3Photo = Boolean(
    isV3PenTestRemediationEndpointsEnabled && photoPath && fullPolicyNumber && auth0AccessToken
  );
  const { data: photoBlob } = useGetPetPhotoQuery(
    { photoUrl, fullPolicyNumber, auth0Token: auth0AccessToken },
    { skip: !shouldFetchV3Photo }
  );
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!photoBlob) {
      setBlobUrl(null);
      return undefined;
    }

    const objectUrl = URL.createObjectURL(photoBlob);
    setBlobUrl(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [photoBlob]);

  if (!isV3PenTestRemediationEndpointsEnabled || !photoPath) return photoUrl;

  return blobUrl;
};
